// extracted by mini-css-extract-plugin
export var kicker = "Heading-module--kicker--Ikwea";
export var heading = "Heading-module--heading--3h2w7";